<svg 
    [ngClass]="IconClass"
    x="0px"
    y="0px"
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14"
    focusable="false">
    <polygon points="2,4 12,4 7,10"></polygon>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-down-arrow.html